(function () {
  function initShopCategory(section) {
    const slider = section.querySelector('[class*="shop-category-slider-"]');
    if (!slider) return;
    if (slider.swiper) {slider.swiper.destroy(true, true);}
    const nextBtn = section.querySelector('[class*="shop-category-next-"]');
    const prevBtn = section.querySelector('[class*="shop-category-prev-"]');
    new Swiper(slider, {
      loop:true,
      spaceBetween: 18,
      slidesPerView:3,
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        768: {
          loop:false,
          slidesPerView: parseInt(getComputedStyle(section).getPropertyValue('--desktop-columns')) || 5
        }
      }
    });
  }
  function initAll() {
    document
      .querySelectorAll('.shop-category')
      .forEach(function (section) {
        initShopCategory(section);
      });
  }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initShopCategory(event.target);
  });
  document.addEventListener('shopify:section:reorder', initAll);
})();